import React, { useEffect, useState } from "react";
import { Table, Button, Empty } from "antd";
import {
  LoadingOutlined,
  BellOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { colors } from "../../core/theme";
import SendNotification from "../Modals/SendNotification";
import { translate } from "../../locale";
import DashServices from "../../services/DashServices";
import { TableHelper } from "../../helpers/TableHelper";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const OutRangeSelfEvaluations = ({ selectedData }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [selecteUser, setSelecteUser] = useState(null);

  const navigate = useNavigate();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-2">
          <Button
            type="link"
            size="small"
            onClick={() => {
              handleSendNotification(record.username);
            }}
          >
            <BellOutlined className="text-black " />
          </Button>
        </div>
      ),
    },
    {
      title: "Apellido",
      dataIndex: "surname",
      key: "surname",
      align: "center",
      render: (_, record) => (
        <a
          onClick={() => navigate(`/admin/buscar-paciente/${record.username}`)}
          className="text-black hover:text-custom_primary"
        >
          {record.surname}
        </a>
      ),
      sorter: { multiple: 2 },
    },
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      align: "center",
      render: (_, record) => (
        <a
          onClick={() => navigate(`/admin/buscar-paciente/${record.username}`)}
          className="text-black hover:text-custom_primary"
        >
          {record.name}
        </a>
      ),
      sorter: { multiple: 3 },
    },
    {
      title: "Fuera de rango",
      dataIndex: "out_of_range",
      key: "out_of_range",
      align: "center",
      render: (_, record) => (
        <div className="flex space-x-4 justify-center">
          <div className="flex space-x-2 items-center">
            <span>{record.out_of_range.danger}</span>{" "}
            <InfoCircleOutlined style={{ color: colors.custom_red }} />
          </div>
          <div className="flex space-x-2 items-center">
            <span>{record.out_of_range.warning}</span>{" "}
            <InfoCircleOutlined style={{ color: colors.custom_yellow }} />
          </div>
        </div>
      ),
      sorter: { multiple: 1 },
    },
  ];

  useEffect(() => {
    if (selectedData) {
      let data = {
        page_size: tableParams.pagination.pageSize,
        page_num: tableParams.pagination.current,
      };
      const sorter = TableHelper.sorter(tableParams);
      if (sorter !== null) {
        data = { ...data, order_by: sorter };
      }
      loadData(data);
    }
  }, [selectedData, JSON.stringify(tableParams)]);

  const loadData = async (data) => {
    setLoading(true);
    try {
      let response = await DashServices.OutRangeAutoevaluate(
        selectedData.period,
        selectedData.suscription,
        data
      );
      if (response.status >= 200 && response.status < 300) {
        setData(
          response.data.data.filter(
            (i) => i.out_of_range.danger !== 0 || i.out_of_range.warning !== 0
          )
        );
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSendNotification = (username) => {
    setSelecteUser(username);
    setShowNotification(true);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  return (
    <>
      <Table
        rowKey={(i) => i.username}
        dataSource={data}
        columns={columns}
        loading={
          loading
            ? { indicator: antIcon, className: "text-custom_blue" }
            : false
        }
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
        pagination={{ ...tableParams.pagination, total: total }}
        onChange={handleTableChange}
      />
      <SendNotification
        patient={selecteUser}
        visible={showNotification}
        onCancel={() => setShowNotification(false)}
        onComplete={() => setShowNotification(false)}
      />
    </>
  );
};

export default OutRangeSelfEvaluations;
